import request from "./request";
export const http = {
  //回收商外部机型绑定-外部渠道列表
  getMachineChannelList(params) {
    return request({
      method: "GET",
      url: "/platform/pc/machine/model/out/merchant/getMachineChannelList",
      data: params,
    });
  },
  //回收商外部机型绑定-查询品牌下拉列表（外部）
  getOutMachineBrandSelectList(params) {
    return request({
      method: "GET",
      url:
        "/platform/pc/machine/model/out/merchant/getOutMachineBrandSelectList",
      params: params,
    });
  },
  //回收商外部机型绑定-绑定机型列表
  getList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/machine/model/out/merchant/list",
      data: params,
    });
  },
  //回收商外部机型绑定-更新报价
  refreshPai(params) {
    return request({
      method: "GET",
      url: "/platform/pc/machine/model/out/merchant/refreshPai",
      params: params,
    });
  },
  //回收商外部机型绑定-导出
  exportExcel(params) {
    return request({
      method: "POST",
      url: "/platform/pc/machine/model/out/merchant/excel",
      data: params,
      responseType: "blob",
    });
  },
  //回收商外部机型绑定-查看机型功能项
  getOutMachineOptionPrice(params) {
    return request({
      method: "GET",
      url: "/platform/pc/machine/model/out/merchant/getOutMachineOptionPrice",
      params: params,
    });
  },
  //回收商外部机型绑定-查询机型下拉列表（平台）
  platformMachineSelectList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/machine/model/out/merchant/platformMachineSelectList",
      data: params,
    });
  },
  //回收商外部机型绑定-绑定本地已有机型
  doBindInPlatform(params) {
    return request({
      method: "POST",
      url: "/platform/pc/machine/model/out/merchant/doBindInPlatform",
      data: params,
    });
  },
    //回收商外部机型绑定-查询机型详情（平台）
    getPlatformMachine(params) {
      return request({
        method: "GET",
        url: "/platform/pc/machine/model/out/merchant/getPlatformMachine",
        params: params,
      });
    },
    //回收商外部机型绑定-取消绑定（平台）
    cancelBind(params) {
      return request({
        method: "GET",
        url: "/platform/pc/machine/model/out/merchant/cancelBind",
        params: params,
      });
    },
  //获取低端机故障列表
  getLowFailureList(params) {
    return request({
      method: 'POST',
      url: '/platform/pc/lowFailure/list',
      data: params
    })
  },
  //添加低端机故障
  addLowFault(params) {
    return request({
      method: 'POST',
      url: '/platform/pc/lowFailure/addLowFault',
      data: params
    })
  },
  // 获取机型配置
  getLowMachineConfig(params) {
    return request({
      method: 'GET',
      url: '/platform/pc/lowFailure/getMachineConfig',
      params,
    })
  },
  // 保存机型配置
  saveLowMachineConfig(params) {
    return request({
      method: 'POST',
      url: '/platform/pc/lowFailure/saveMachineConfig',
      data: params,
    })
  },
  // 修改低端机故障项排序
  updateLowFaultSort(params) {
    return request({
      method: 'GET',
      url: '/platform/pc/lowFailure/updateLowFaultSort',
      params,
    })
  },
  // 是否启用低端机故障项
  updateLowFaultIsEnable(params) {
    return request({
      method: 'GET',
      url: '/platform/pc/lowFailure/updateLowFaultIsEnable',
      params,
    })
  },
  // 删除低端机项
  removeLowFaultById(params) {
    return request({
      method: 'GET',
      url: '/platform/pc/lowFailure/removeLowFaultById',
      params,
    })
  },
  // 获取外部低端机故障列表
  getLowFailureOutList(params) {
    return request({
      method: 'POST',
      url: '/platform/pc/lowFailure/outList',
      data: params,
    })
  },
  // 绑定
  bindLowFailure(params) {
    return request({
      method: 'GET',
      url: '/platform/pc/lowFailure/bind',
      params,
    })
  },
  // 取消绑定
  cancelLowBind(params) {
    return request({
      method: 'GET',
      url: '/platform/pc/lowFailure/cancelBind',
      params,
    })
  },
  // 查看绑定
  getBind(params) {
    return request({
      method: 'GET',
      url: '/platform/pc/lowFailure/getBind',
      params,
    })
  },
  // 查看已绑定功能项
  getHasBind(params) {
    return request({
      method: 'GET',
      url: '/platform/pc/lowFailure/getHasBind',
      params,
    })
  },
  // 低端机旧机分类
  selectLowList(params) {
    return request({
      method: 'GET',
      url: '/platform/pc/oldMachineType/selectLowList',
      params,
    })
  },
   // 获取识图记录
   getmapRecords(params) {
    return request({
      method: 'POST',
      url: '/platform/pc/machine/model/mapRecords',
      data: params,
    })
  },
   // 查看匹配结果
   checkResults(params) {
    return request({
      method: 'GET',
      url: '/platform/pc/machine/model/checkResults',
      params,
    })
  },
};
